import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';

import { FiltersService } from '../../filters.service';
import { FiltersStateService } from '../../common';
import { ListItem, ListItemType } from '../../list-items';

@Component({
  selector: 'list-panel',
  templateUrl: './list-panel.component.html',
  styleUrls: ['./list-panel.component.scss'],
  host: { class: 'list-panel' },
  encapsulation: ViewEncapsulation.None
})
export class ListPanelComponent implements OnInit, OnDestroy {

  @Input() data: ListItem[];
  @Input() header: string | null;
  @Input() travelStyle: string;

  type?: ListItemType;

  constructor(
    public service: FiltersService,
    public filtersService: FiltersStateService
  ) { }

  ngOnInit(): void {

    if (this.travelStyle === '')      (this.type = 'exp')
    if (this.header === 'Hotel Type') (this.type = 'hotelType')
    if (this.header === 'Amenities')  (this.type = 'amenities')
    if (this.header === 'Activities') (this.type = 'activities')

    if (this.travelStyle === '' && !this.header) {
      this.type = 'hotelType'
    }

    this.service.overlayState$$.next(true);

    this.service.searchPage$.subscribe(route => {
      if (this.travelStyle === '' && route === 'hotels') {
        this.type = 'hotelType'
      }
      if (this.travelStyle === '' && route === 'foodanddrink') {
        this.type = 'amenities'
      }
      if (this.travelStyle === '' && route === 'thingstodo') {
        this.type = 'activities'
      }
    });
  }

  ngOnDestroy(): void {
    this.service.overlayState$$.next(false);
  }

  get highlight(): boolean {
    return this.travelStyle === '' && ![ 'amenities', 'activities', 'hotelType' ].includes(this.type!);
  }

  toggleSelection(value: string): void {

    if (this.travelStyle === '' && [ 'amenities', 'activities', 'hotelType' ].includes(this.type!))
      return this.toggleHighlightSelection(value);

    let selected = this.filtersService[this.travelStyle === '' ? 'selectedTravelStyles$$' : this.type === 'hotelType' ? 'hotelTypeItems$$' : 'selectedItems$$'].value.map(e => e?.value).filter(Boolean);
    selected.includes(value)
      ? selected = selected.filter(e => e !== value)
      : selected.push(value);

    const data = this.data.slice(0);
    data.map(value => {
      if (value.type === 'hotelType') {
        value.type = 'amenities'
      }
      return value;
    });

    this.filtersService[this.travelStyle === '' ? 'selectedTravelStyles$$' : this.type === 'hotelType' ? 'hotelTypeItems$$'  : 'selectedItems$$'].next(
      data.filter((listItem: ListItem) => selected.includes(listItem.value))
    );
  }

  toggleHighlightSelection(value: string): void {

    let selected = this.filtersService[this.type === 'hotelType' ? 'hotelTypeItems$$'  : 'selectedItems$$'].value.map(e => e.value);
    selected.includes(value)
      ? selected = selected.filter(e => e !== value)
      : selected.push(value);

    const data = this.data.slice(0);
    data.map(value => {
      if (value.type === 'hotelType') {
        value.type = 'amenities'
      }
      return value;
    });

    const results = data.filter((listItem: ListItem) => selected.includes(listItem.value));
    this.filtersService[this.type === 'hotelType' ? 'hotelTypeItems$$'  : 'selectedItems$$'].next(results);
  }

  applyFilters(): void {
    this.filtersService.panelFilterApplyClicked$$.next();
  }
  
  clearFilters(): void {
    this.filtersService.clearFilters();
    this.filtersService.panelFilterClearClicked$$.next();
  }

}
